module.exports = __webpack_public_path__ + "static/media/launch_shipyard_marker.17c2fbe8.svg";